import React, { useState, useEffect } from 'react';
import emailjs from '@emailjs/browser'; // <-- IMPORT EMAILJS
import logoIcon from '../images/logo_Icon.png';
import {
  FaArrowRight,
  FaEnvelope,
  FaPhone,
  FaMapMarkerAlt,
  FaLinkedinIn,
  FaFacebookF,
  FaInstagram,
  FaTiktok
} from 'react-icons/fa';
import './Contact.css';

// EmailJS keys loaded from environment variables (.env.local)
const SERVICE_ID = process.env.REACT_APP_EMAILJS_SERVICE_ID;
const TEMPLATE_ID = process.env.REACT_APP_EMAILJS_TEMPLATE_ID;
const PUBLIC_KEY = process.env.REACT_APP_EMAILJS_PUBLIC_KEY;

export default function Contact() {
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    let link = document.querySelector("link[rel='canonical']");
    if (!link) { link = document.createElement('link'); link.rel = 'canonical'; document.head.appendChild(link); }
    link.href = 'https://www.ceylonext.com/contact';
    document.title = 'Contact Us | CeyloNext';
  }, []);

  /**
   * Handles the form submission using EmailJS.
   */
  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    // This sends the email using the form element (e.target)
    emailjs.sendForm(SERVICE_ID, TEMPLATE_ID, e.target, PUBLIC_KEY)
      .then((result) => {
        alert('Thank you for your message! We will get back to you soon.');
        e.target.reset();
      })
      .catch((error) => {
        alert('Oops! Something went wrong. Please try again.');
      })
      .finally(() => {
        setIsSubmitting(false); // Re-enable the button
      });
  };

  return (
    <main className="main-content">
      <div className="hero-text">
        <h1>Let's Get in Touch</h1>
        <p>
          We're excited to hear about your project. Fill out the form below,
          and a member of our team will get back to you shortly.
        </p>
      </div>

      <div className="contact-content">

        {/* === Contact Form === */}
        {/* Make sure your form's `name` attributes 
          match the variables in your EmailJS template.
          (name, email, subject, message)
        */}
        <form className="contact-form" onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="name">Full Name</label>
            <input type="text" id="name" name="name" required />
          </div>
          <div className="form-group">
            <label htmlFor="email">Email Address</label>
            <input type="email" id="email" name="email" required />
          </div>
          <div className="form-group">
            <label htmlFor="subject">Subject</label>
            <input type="text" id="subject" name="subject" required />
          </div>
          <div className="form-group">
            <label htmlFor="message">Your Message</label>
            <textarea id="message" name="message" rows="6" required></textarea>
          </div>

          <button
            type="submit"
            className="transform-button"
            disabled={isSubmitting} // Disable button while sending
          >
            {isSubmitting ? 'Sending...' : 'Send Message'}
            <div className="arrow-circle">
              <FaArrowRight />
            </div>
          </button>
        </form>

        {/* === Contact Info Panel === */}
        <aside className="contact-info">
          <h3>Contact Information</h3>
          <p>
            <FaMapMarkerAlt />
            <span>
              <img src={logoIcon} alt="CeyloNext Logo" style={{ width: '32px', height: '32px', marginRight: '8px', verticalAlign: 'middle' }} />
              CeyloNext,<br />
              Sri Lanka.
            </span>
          </p>
          <a href="mailto:contact@ceylonext.com">
            <FaEnvelope />
            <span>contact@ceylonext.com</span>
          </a>
          <a href="tel:+94768718183">
            <FaPhone />
            <span>+94 76 871 8183</span>
          </a>

          <h3>Follow Us</h3>
          <div className="social-icons">
            <a href="https://www.linkedin.com/company/ceylonext/" target="_blank" rel="noopener noreferrer"><FaLinkedinIn /></a>
            <a href="https://www.facebook.com/share/1UWD6nVTPA/?mibextid=wwXIfr" target="_blank" rel="noopener noreferrer"><FaFacebookF /></a>
            <a href="https://www.instagram.com/ceylonext?igsi=MXU5ZGRkMmdic2ZuMw==&utm_source=ig_contact_invite" target="_blank" rel="noopener noreferrer"><FaInstagram /></a>
            <a href="https://www.tiktok.com/@ceylonext" target="_blank" rel="noopener noreferrer"><FaTiktok /></a>
          </div>
        </aside>
      </div>
    </main>
  );
}